document.addEventListener("DOMContentLoaded", () => {
  /**
   * Product Booking Component
   *
   * Usage:
   *
   * <div
   *   class="productBooking-2167267121278"
   *   data-product-id="2167267121278"
   *   data-variant-id="123456789"
   *   data-appointment-type-id="1"
   * ></div>
   *
   */

  const bookingContainers = document.querySelectorAll(
    '[class*="productBooking-"]',
  );

  if (!bookingContainers.length) {
    return;
  }
  /**
   * Render booking component
   */
  async function renderBooking(container) {
    const productId = container.dataset.productId;
    const variantId = container.dataset.variantId;
    const appointmentTypeId = container.dataset.appointmentTypeId;

    if (!productId || !variantId || !appointmentTypeId) {
      console.error(
        "Product booking: Missing productId, variantId or appointmentTypeId.",
        container,
      );

      container.innerHTML = `
        <p class="mtgtw:py-5!">
          Booking information is unavailable.
        </p>
      `;

      return;
    }

    const availabilityUrl =
      "https://app.learnpac.co.uk/wp-json/shopify/v1/appointment-types/" +
      appointmentTypeId +
      "/availability?type=3";

    /*
     * Loading state
     */
    container.innerHTML = `
      <div
        id="availability-list"
        class="mtgtw:flex mtgtw:flex-col mtgtw:w-full mtgtw:h-auto mtgtw:overflow-y-auto mtgtw:[scrollbar-width:_thin]! mtgtw:scrollbar-thumb-primary/10! mtgtw:scrollbar-track-primary/5! mtgtw:group"
      >
        <div class="mtgtw:flex! mtgtw:gap-5! mtgtw:w-full! mtgtw:items-center! mtgtw:py-3! mtgtw:border-[#E0E0E0] mtgtw:border-t!">
          <div class="mtgtw:w-full!">
            <div class="mtgtw:h-6! mtgtw:w-52! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div>
            <div class="mtgtw:h-5! mtgtw:w-36! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse! mtgtw:mt-2!"></div>
          </div>
          <div><div class="mtgtw:h-6! mtgtw:w-10! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
          <div><div class="mtgtw:h-10! mtgtw:w-24! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
        </div>
        <div class="mtgtw:flex! mtgtw:gap-5! mtgtw:w-full! mtgtw:items-center! mtgtw:py-3! mtgtw:border-[#E0E0E0] mtgtw:border-t!">
          <div class="mtgtw:w-full!"><div class="mtgtw:h-6! mtgtw:w-52! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div><div class="mtgtw:h-5! mtgtw:w-36! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse! mtgtw:mt-2!"></div></div>
          <div><div class="mtgtw:h-6! mtgtw:w-10! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
          <div><div class="mtgtw:h-10! mtgtw:w-24! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
        </div>
        <div class="mtgtw:flex! mtgtw:gap-5! mtgtw:w-full! mtgtw:items-center! mtgtw:py-3! mtgtw:border-[#E0E0E0] mtgtw:border-t!">
          <div class="mtgtw:w-full!"><div class="mtgtw:h-6! mtgtw:w-52! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div><div class="mtgtw:h-5! mtgtw:w-36! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse! mtgtw:mt-2!"></div></div>
          <div><div class="mtgtw:h-6! mtgtw:w-10! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
          <div><div class="mtgtw:h-10! mtgtw:w-24! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
        </div>
        <div class="mtgtw:flex! mtgtw:gap-5! mtgtw:w-full! mtgtw:items-center! mtgtw:py-3! mtgtw:border-[#E0E0E0] mtgtw:border-t!">
          <div class="mtgtw:w-full!"><div class="mtgtw:h-6! mtgtw:w-52! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div><div class="mtgtw:h-5! mtgtw:w-36! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse! mtgtw:mt-2!"></div></div>
          <div><div class="mtgtw:h-6! mtgtw:w-10! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
          <div><div class="mtgtw:h-10! mtgtw:w-24! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
        </div>
        <div class="mtgtw:flex! mtgtw:gap-5! mtgtw:w-full! mtgtw:items-center! mtgtw:py-3! mtgtw:border-[#E0E0E0] mtgtw:border-t!">
          <div class="mtgtw:w-full!"><div class="mtgtw:h-6! mtgtw:w-52! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div><div class="mtgtw:h-5! mtgtw:w-36! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse! mtgtw:mt-2!"></div></div>
          <div><div class="mtgtw:h-6! mtgtw:w-10! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
          <div><div class="mtgtw:h-10! mtgtw:w-24! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
        </div>
        <div class="mtgtw:flex! mtgtw:gap-5! mtgtw:w-full! mtgtw:items-center! mtgtw:py-3! mtgtw:border-[#E0E0E0] mtgtw:border-t!">
          <div class="mtgtw:w-full!"><div class="mtgtw:h-6! mtgtw:w-52! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div><div class="mtgtw:h-5! mtgtw:w-36! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse! mtgtw:mt-2!"></div></div>
          <div><div class="mtgtw:h-6! mtgtw:w-10! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
          <div><div class="mtgtw:h-10! mtgtw:w-24! mtgtw:bg-gray-200! mtgtw:rounded! mtgtw:animate-pulse!"></div></div>
        </div>
      </div>
    `;

    const skeletonList = container.querySelector('#availability-list');

    if (skeletonList) {
      const skeletonHeader = document.createElement('div');

      skeletonHeader.innerHTML = `
        <div class="mtgtw:grid! mtgtw:grid-cols-32! mtgtw:grid-rows-auto! mtgtw:gap-1!">
          <div class="mtgtw:w-full! mtgtw:col-span-12! mtgtw:min-[1250px]:col-span-10! mtgtw:min-[1300px]:col-span-12! mtgtw:min-[1490px]:col-span-10! mtgtw:flex! mtgtw:items-center! mtgtw:justify-start!">
            <p class="mtgtw:text-lg! mtgtw:font-bold! mtgtw:font-mtgmontserrat! mtgtw:text-primary! mtgtw:m-0!">Date &amp; time</p>
          </div>
          <div class="mtgtw:col-span-14! mtgtw:min-[1250px]:col-span-8! mtgtw:min-[1300px]:col-span-14! mtgtw:min-[1490px]:col-span-8! mtgtw:flex! mtgtw:items-center! mtgtw:justify-center!">
            <p class="mtgtw:text-lg! mtgtw:font-bold! mtgtw:font-mtgmontserrat! mtgtw:text-primary! mtgtw:flex! mtgtw:items-center! mtgtw:gap-2! mtgtw:text-nowrap! mtgtw:m-0!">Available Seats</p>
          </div>
          <div class="mtgtw:col-span-0!"></div>
          <div class="mtgtw:col-span-0!"></div>
        </div>
      `;

      skeletonList.prepend(skeletonHeader);

      Array.from(skeletonList.children).slice(1).forEach((row) => {
        row.className =
          'mtgtw:grid! ' +
          'mtgtw:grid-cols-32! ' +
          'mtgtw:grid-rows-auto! ' +
          'mtgtw:gap-1! ' +
          'mtgtw:w-full! ' +
          'mtgtw:py-3! ' +
          'mtgtw:pr-2! ' +
          'mtgtw:border-[#E0E0E0] ' +
          'mtgtw:border-t!';

        const skeletonColumns = row.children;

        skeletonColumns[0].className =
          'mtgtw:w-full! ' +
          'mtgtw:col-span-12! ' +
          'mtgtw:min-[1250px]:col-span-10! ' +
          'mtgtw:min-[1300px]:col-span-12! ' +
          'mtgtw:min-[1490px]:col-span-10!';

        skeletonColumns[1].className =
          'mtgtw:col-span-14! ' +
          'mtgtw:min-[1250px]:col-span-8! ' +
          'mtgtw:min-[1300px]:col-span-14! ' +
          'mtgtw:min-[1490px]:col-span-8! ' +
          'mtgtw:flex! ' +
          'mtgtw:items-center! ' +
          'mtgtw:justify-center!';

        skeletonColumns[2].className =
          'mtgtw:col-span-6! ' +
          'mtgtw:min-[1250px]:col-span-5! ' +
          'mtgtw:min-[1300px]:col-span-6! ' +
          'mtgtw:min-[1490px]:col-span-5! ' +
          'mtgtw:flex! ' +
          'mtgtw:items-center! ' +
          'mtgtw:justify-end!';
      });
    }

    try {
      const response = await fetch(availabilityUrl);

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      const items =
        Array.isArray(data) ? data
        : Array.isArray(data?.items) ? data.items
        : Array.isArray(data?.data) ? data.data
        : Array.isArray(data?.value) ? data.value
        : [];

      /*
       * No availability
       */
      if (!items.length) {
        container.innerHTML = `
          <p class="mtgtw:py-5!">
            No availability found.
          </p>
        `;

        return;
      }

      /*
       * Create booking list
       */
      const availabilityList = document.createElement("div");

      availabilityList.className = "productBookingLoadedContainer mtgtw:w-full! mtgtw:max-h-[250px]! mtgtw:overflow-y-auto! mtgtw:[scrollbar-width:_thin]! mtgtw:scrollbar-thumb-primary/10! mtgtw:scrollbar-track-primary/5!";

      const availabilityHeader = document.createElement("div");
      availabilityHeader.classList = "mtgtw:sticky! mtgtw:top-0! mtgtw:bg-white! mtgtw:z-1! mtgtw:border-[#E0E0E0] mtgtw:border-b!";

      availabilityHeader.innerHTML = `
          <div class="mtgtw:grid! mtgtw:grid-cols-32! mtgtw:grid-rows-auto! mtgtw:gap-1!">
            <div
              class="mtgtw:w-full! mtgtw:col-span-12! mtgtw:min-[1250px]:col-span-9! mtgtw:min-[1300px]:col-span-12! mtgtw:min-[1490px]:col-span-9! mtgtw:flex! mtgtw:items-center! mtgtw:justify-start!"
            >
              <p class="mtgtw:text-lg! mtgtw:font-bold! mtgtw:font-mtgmontserrat! mtgtw:text-primary! mtgtw:m-0!">
                Date &amp; time
              </p>
            </div>
            <div
              class="mtgtw:col-span-14! mtgtw:min-[1250px]:col-span-10! mtgtw:min-[1300px]:col-span-14! mtgtw:min-[1490px]:col-span-10! mtgtw:flex! mtgtw:items-center! mtgtw:justify-center!"
            >
              <p
                class="mtgtw:text-lg! mtgtw:font-bold! mtgtw:font-mtgmontserrat! mtgtw:text-primary! mtgtw:flex! mtgtw:items-center! mtgtw:gap-2! mtgtw:text-nowrap! mtgtw:m-0!"
              >
                Available Seats
              </p>
            </div>
            <div class="mtgtw:col-span-0!"></div>
          </div>
        `;

      availabilityList.appendChild(availabilityHeader);

      items.forEach((item) => {
        const row = document.createElement("div");

        row.className =
          "mtgtw:grid! " +
          "mtgtw:grid-cols-32! " +
          "mtgtw:grid-rows-auto! " +
          "mtgtw:gap-1! " +
          "mtgtw:w-full! " +
          "mtgtw:py-3! " +
          "mtgtw:pr-2! " +
          "mtgtw:border-[#E0E0E0] " +
          "mtgtw:border-t! " +
          "mtgtw:transition-opacity " +
          "mtgtw:group-hover:opacity-50 " +
          "mtgtw:hover:opacity-100!";

        const timeSlot = item.timeSlots?.[0] || "";

        const availableSeats = Number(item.available_seats || 0);

        /*
         * Quantity options
         */
        const quantityOptions = Array.from(
          { length: Math.max(availableSeats - 1, 0) },
          (_, index) => {
            const value = index + 2;

            return `
              <option value="${value}">
                ${value}
              </option>
            `;
          },
        ).join("");

        row.innerHTML = `

          <!-- DATE / TIME -->

          <div
            class="
              mtgtw:w-full!
              mtgtw:col-span-12!
              mtgtw:min-[1250px]:col-span-9!
              mtgtw:min-[1300px]:col-span-12!
              mtgtw:min-[1490px]:col-span-9!
              mtgtw:flex!
              mtgtw:items-center!
              mtgtw:justify-start!
            "
          >

            <div>

              <p
                class="
                  mtgtw:text-xl!
                  mtgtw:font-bold!
                  mtgtw:font-mtgmontserrat!
                  mtgtw:text-primary!
                "
              >
                ${item.date}
              </p>

              <p
                class="
                  mtgtw:text-lg!
                  mtgtw:font-semibold!
                  mtgtw:font-mtgmontserrat!
                  mtgtw:text-primary!
                "
              >
                ${timeSlot} - 4:30pm
              </p>

            </div> 

          </div>


          <!-- AVAILABLE SEATS -->

          <div
            class="
              mtgtw:col-span-14!
              mtgtw:min-[1250px]:col-span-10!
              mtgtw:min-[1300px]:col-span-14!
              mtgtw:min-[1490px]:col-span-10!
              mtgtw:flex!
              mtgtw:items-center!
              mtgtw:justify-center!
              mtgtw:gap-4!
            "
          >

            <p
              class="
                mtgtw:text-2xl!
                mtgtw:font-bold!
                mtgtw:font-mtgmontserrat!
                mtgtw:text-primary!
                mtgtw:flex!
                mtgtw:min-[1490px]:items-center!
                mtgtw:gap-2!
                mtgtw:text-nowrap!
              "
            >
              ${availableSeats}
            </p>

          <!-- QUANTITY -->

          <div
            class="
              mtgtw:flex!
              mtgtw:items-center!
              mtgtw:min-[1490px]:justify-center!
              mtgtw:justify-end!
              ${availableSeats === 0 ? "mtgtw:invisible!" : "mtgtw:visible!"}
            "
          >

            <div class="mtgtw:relative!">

              <select
                data-quantity-select
                class="
                  mtgtw:border!
                  mtgtw:border-[#E0E0E0]!
                  mtgtw:h-[32px]!
                  mtgtw:w-[40px]!
                  mtgtw:bg-[#F6F6F6]!
                  mtgtw:rounded-xl!
                  mtgtw:px-2!
                  mtgtw:text-start!
                  mtgtw:font-mtgmontserrat!
                  mtgtw:text-primary!
                  mtgtw:font-semibold!
                "
                ${availableSeats === 0 ? "disabled" : ""}
              >

                ${quantityOptions}

              </select>


              <svg
                class="
                  mtgtw:pointer-events-none!
                  mtgtw:absolute!
                  mtgtw:right-4!
                  mtgtw:top-1/2!
                  mtgtw:-translate-y-1/2!
                  mtgtw:w-5!
                  mtgtw:h-5!
                  mtgtw:text-primary!
                "
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >

                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m19 9-7 7-7-7"
                />

              </svg>

            </div>

          </div>


          </div>

          <!-- BOOK BUTTON -->

          <div
            class="
              mtgtw:col-span-32!
              mtgtw:min-[1250px]:col-span-13!
              mtgtw:min-[1300px]:col-span-32!
              mtgtw:min-[1490px]:col-span-13!
              mtgtw:flex!
              mtgtw:items-center!
              mtgtw:justify-end!
            "
          >

            <button
              type="button"

              data-booking-button

              data-date="${item.date}"

              data-timeslot="${timeSlot}"

              data-product-id="${productId}"

              data-variant-id="${variantId}"

              data-available-seats="${availableSeats}"

              class="
                mtgtw:py-2!
                mtgtw:px-2!
                mtgtw:w-full!
                mtgtw:h-full!
                mtgtw:rounded-full!
                mtgtw:leading-normal!
                mtgtw:text-lg!
                mtgtw:font-mtgmontserrat!
                mtgtw:font-semibold!
                mtgtw:text-nowrap!
                ${
                  availableSeats === 0 ?
                    "mtgtw:bg-red-700! mtgtw:text-white!"
                  : "mtgtw:bg-secondary! mtgtw:text-white!"
                }
              "

              ${availableSeats === 0 ? "disabled" : ""}
            >

              ${availableSeats === 0 ? "FULLY BOOKED" : "BOOK TWO TRAINERS"}

            </button>

          </div>

        `;

        /*
         * BOOK NOW
         */
        const button = row.querySelector("[data-booking-button]");

        const quantitySelect = row.querySelector("[data-quantity-select]");

        if (button && !button.disabled) {
          button.addEventListener("click", async () => {
            button.textContent = "BOOKING...";
            button.disabled = true;

            /*
             * Disable all other booking buttons
             * within THIS booking component only.
             */
            const allButtons = availabilityList.querySelectorAll(
              "[data-booking-button]",
            );

            allButtons.forEach((candidate) => {
              if (candidate !== button) {
                candidate.disabled = true;
              }
            });

            const quantity = Number.parseInt(quantitySelect?.value || "1", 10);

            const safeQuantity =
              Number.isNaN(quantity) || quantity < 1 ?
                1
              : Math.min(quantity, Number(button.dataset.availableSeats || 1));

            /*
             * Shopify cart item
             */
            const bookingData = {
              id: Number(button.dataset.variantId),

              quantity: safeQuantity,

              properties: {
                Date: button.dataset.date,

                Timeslot: button.dataset.timeslot,
              },
            };

            try {
              /*
               * Clear cart
               */
              const clearResponse = await fetch("/cart/clear.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
              });

              if (!clearResponse.ok) {
                throw new Error("Unable to clear cart.");
              }

              /*
               * Add booking
               */
              const addResponse = await fetch("/cart/add.js", {
                method: "POST",

                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },

                body: JSON.stringify({
                  items: [bookingData],
                }),
              });

              if (!addResponse.ok) {
                let addError = "Unable to add booking.";

                try {
                  const errorData = await addResponse.json();
                  addError =
                    errorData.description ||
                    errorData.message ||
                    errorData.error ||
                    addError;
                } catch (parseError) {
                  // Shopify may return an empty or non-JSON error response.
                }

                throw new Error(addError);
              }

              /*
               * Go directly to checkout
               */
              window.location.href = "/checkout";
            } catch (error) {
              console.error("Booking error:", error);

              button.textContent = error.message || "BOOK NOW";

              button.disabled = false;

              allButtons.forEach((candidate) => {
                candidate.disabled = false;
              });
            }
          });
        }

        availabilityList.appendChild(row);
      });

      /*
       * Put list inside container
       */
      container.innerHTML = "";

      container.appendChild(availabilityList);
    } catch (error) {
      console.error("Failed to load availability:", error);

      container.innerHTML = `
        <p class="mtgtw:py-5!">
          Unable to load availability.
        </p>
      `;
    }
  }

  /*
   * Render every booking component
   */
  bookingContainers.forEach((container) => {
    renderBooking(container);
  });
});
